import moment from "moment";
import { deburr } from "lodash";

export type StringParsableType =
  | "string"
  | "number"
  | "boolean"
  | "date"
  | undefined;

type StringParserReturnType = string | number | boolean | Date | undefined;

export type StringParserFunction = (val: string) => StringParserReturnType;
export type StringParserArrayFunction = (
  val: string
) => StringParserReturnType[];
export abstract class StringParserClass<T> {
  public abstract fromString(value: string): T;
}
export type StringParser =
  | StringParserFunction
  | StringParserArrayFunction
  | StringParserClass<any>;

export class String {
  public static parse(
    val: string,
    type?: StringParsableType
  ): string | number | boolean | Date | undefined {
    if (type === "number") {
      return String.parseNumber(val);
    }
    if (type === "boolean") {
      return String.parseBoolean(val);
    }
    if (type === "date") {
      return String.parseDate(val);
    }
    return String.parseString(val);
  }

  public static parseString(val: string): string {
    return val.trim();
  }

  public static parseNumber(val: string): number | undefined;
  public static parseNumber(val: string, def: number): number;
  public static parseNumber(val: string, def?: number): number | undefined {
    const arr = val
      .toString()
      .replace(",", ".")
      .replace(/[^\d.-]/gm, "")
      .split(".");
    let s: string = arr.pop()!;
    if (arr.length > 0) {
      s = arr.join("") + "." + s;
    }
    const r = parseFloat(s);
    if (isNaN(r) && def !== undefined) {
      return def;
    }
    if (isNaN(r)) {
      return undefined;
    }
    return r;
  }

  public static parseBoolean(val: string): boolean {
    const s = val.toString().trim();
    if (s === "0" || s === "false") {
      return false;
    } else {
      return Boolean(s);
    }
  }

  public static parseDate(val: string): Date {
    const s = val.toString().trim();
    const d = moment.utc(s, "DD/MM/YYYY HH:mm", true);
    if (!d.isValid()) {
      return new Date(0);
    }
    return d.toDate();
  }

  public static parseArray = <P extends StringParserFunction>(
    parser: P,
    separator?: string
  ) => (val: string) => {
    separator = separator || ",";
    return val.split(separator).map(v => parser(v));
  };

  public static uniqKey(s: string, exists: string[] = []): string {
    let key: string = deburr(s.toLowerCase())
      .replace(/[^\w ]/g, "")
      .replace(" ", "-");
    if (exists.indexOf(key) > -1) {
      let i = 0;
      while (exists.indexOf(key + "-" + i.toString()) > -1) {
        i++;
      }
      key += "-" + i.toString();
    }
    return key;
  }
}
